module.exports = __webpack_public_path__ + "img/badge-product-page-left-corner.ac51bd91.svg";